import { ErrorResponse, NetworkParams, RestService } from "@sinossi/mates-react-library"
import {
    DashboardResponse,
    HotBrandResponse,
} from "models/dashboard"
import {
    AssetMatchBrand,
    BrandPriorityResponse, PaginatedResponse, SearchFilter, TopMatch
} from "../models"
import { DashboardContractsPeriods } from "components/dashboard/dashboard-contracts/models"
import { DashboardContractsData } from "components/dashboard/dashboard-contracts/dashboard-contracts"
import { CreateResearchRequest } from "../models/priorities"

export class DashboardServices {
    static getDashboard = (callback: any, catchCallback: any) => {
        RestService
            .get<DashboardResponse>("/api/dashboard")
            .then(callback)
            .catch(catchCallback)
    }

    static getHotAsset = (callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrand>>("/api/match/hot-matches", new SearchFilter())
            .then(callback)
            .catch(catchCallback)
    }

    static getHotBrand = (callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<HotBrandResponse>>("/api/brand/hot", new SearchFilter())
            .then(callback)
            .catch(catchCallback)
    }

    static getBrandPriorities = (brandId: string, callback: any, catchCallback: any) => {
        RestService
            .get<BrandPriorityResponse>(`/api/brand/${brandId}/priorities`)
            .then(callback)
            .catch(catchCallback)
    }

    static createBrandPriorities = (request: CreateResearchRequest, callback: any, catchCallback: any) => {
        RestService
            .post<any>(`/api/brand/priorities`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getDashboardContracts = (request: DashboardContractsPeriods, callback: any, catchCallback: any) => {
        RestService
            .post<DashboardContractsData>(`/api/dashboard/contracts`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static uploadPrioritiesDocument = (request: FormData, callback: any, catchCallback: any) => {
        const params = new NetworkParams()
        params.contentType = undefined

        RestService
            .genericPost<any, ErrorResponse>(`/api/brand/priorities/template`, request, params)
            .then(callback)
            .catch(catchCallback)
    }
}
